// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__PFvVs","dragIcon":"SortableItem_dragIcon__39deg","disabled":"SortableItem_disabled__2Pe6n"};